module.exports = __webpack_public_path__ + "img/ug533.7bcf7bd1.png";